export default function HowFound() {
  return (
    <div data-testid="how-found-page" className="fixed inset-0 z-[200] bg-[#f6f7f9]">
      <iframe
        src="/how-did-you-find-us.html"
        title="How did you find us?"
        className="h-full w-full border-0"
      />
    </div>
  );
}
